export const CompanyQueryKey = {
  all: ['company'] as const,
  name: () => [...CompanyQueryKey.all, 'name'],
  privacyPolicyList: () => [...CompanyQueryKey.all, 'privacyPolicy'],
  privacyPolicyItem: (policySn: string) => [...CompanyQueryKey.privacyPolicyList(), policySn],
};
